export default __webpack_public_path__ + "static/image-mob-5e2bc2cf074295f52656e3611719c14a.jpg";